<form class="details-form form" [formGroup]="personalDetailsForm()!">
  <mat-form-field appearance="outline">
    <mat-label>First name</mat-label>
    <input matInput placeholder="First name" formControlName="firstName" required />

    @if(personalDetailsForm().get('firstName')?.invalid &&
    personalDetailsForm().get('firstName')?.touched){
    <mat-error> First name is invalid. </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Last name</mat-label>
    <input matInput placeholder="Last name" formControlName="lastName" required />

    @if( (personalDetailsForm().get('lastName')?.invalid &&
    !personalDetailsForm().get('lastName')?.hasError('identicalNames')) ||
    personalDetailsForm().get('lastName')?.value.length === 0){
    <mat-error> Last name is invalid. </mat-error>
    } @else if( personalDetailsForm().get('lastName')?.hasError('identicalNames') &&
    personalDetailsForm().get('lastName')?.value.length > 0){
    <mat-error> First name and last name cannot be identical. </mat-error>
    }
  </mat-form-field>
</form>
